/*
  Diwali candle — floats up from the Add to cart button when a shopper taps it.
  Purely visual: it listens for clicks and never stops, delays or changes the
  add-to-cart action itself. Loaded only when Theme settings > Diwali skin >
  "Candle animation on Add to cart" is on (see layout/theme.liquid).
*/
(function () {
  'use strict';
  if (window.__diwaliCandle) return;
  window.__diwaliCandle = true;

  var script = document.currentScript;
  var CANDLE_SRC = script && script.getAttribute('data-candle');
  if (!CANDLE_SRC || typeof Element === 'undefined' || !Element.prototype.animate) return;

  // Real add-to-cart buttons only (cards, quick shop, product page, sticky bar, wishlist, complete-the-look)
  var TRIGGER = [
    '[data-add-to-cart]',
    'button[name="add"]',
    '[data-cqs-atc]',
    '[data-cqs-add]',
    '#stickyATC',
    '.wl-card__atc',
    '.bp-sec__cta-btn'
  ].join(',');
  // "Choose options" opens the quick-shop popup; sold-out buttons do nothing
  var EXCLUDE = '[data-cqs-trigger],[disabled],[aria-disabled="true"],.gpx-atc-btn--sold';

  var MAX_LIVE = 8;
  var live = 0;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  // warm the image so the first candle appears instantly
  var preload = new Image();
  preload.decoding = 'async';
  preload.src = CANDLE_SRC;

  var style = document.createElement('style');
  style.textContent =
    '.dw-candle-fx{position:fixed;left:0;top:0;width:0;height:0;pointer-events:none;z-index:2147483000;contain:layout style}' +
    '.dw-candle-fx *{pointer-events:none}' +
    '.dw-candle-rise{position:absolute;left:0;top:0;will-change:transform,opacity}' +
    '.dw-candle-sway{position:absolute;left:0;bottom:0;transform-origin:50% 100%;will-change:transform}' +
    '.dw-candle-glow{position:absolute;left:50%;border-radius:50%;' +
      'background:radial-gradient(circle,rgba(255,214,90,.75) 0%,rgba(255,150,30,.35) 38%,rgba(255,110,0,0) 70%);' +
      'transform:translate(-50%,-50%);mix-blend-mode:screen;will-change:transform,opacity}' +
    '.dw-candle-img{position:absolute;left:50%;bottom:0;display:block;max-width:none;height:auto;' +
      'transform:translateX(-50%);filter:drop-shadow(0 4px 10px rgba(199,27,0,.35))}' +
    '.dw-candle-spark{position:absolute;left:0;top:0;border-radius:50%;' +
      'background:radial-gradient(circle,#fffbe6 0%,#ffd84d 45%,rgba(255,180,0,0) 75%);will-change:transform,opacity}';
  document.head.appendChild(style);

  function rand(a, b) { return a + Math.random() * (b - a); }

  function spawn(x, y) {
    if (live >= MAX_LIVE) return;
    live++;

    var small = window.innerWidth < 750;
    var w = small ? 36 : 44;                 // candle width in px
    var h = Math.round(w * 1718 / 1064);     // keeps the artwork's proportions
    var rise = small ? 150 : 190;

    var root = document.createElement('div');
    root.className = 'dw-candle-fx';
    root.setAttribute('aria-hidden', 'true');
    root.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';

    var riseEl = document.createElement('div');
    riseEl.className = 'dw-candle-rise';
    var sway = document.createElement('div');
    sway.className = 'dw-candle-sway';
    sway.style.width = w + 'px';
    sway.style.height = h + 'px';
    sway.style.marginLeft = (-w / 2) + 'px';

    var glow = document.createElement('div');
    glow.className = 'dw-candle-glow';
    var g = w * 2.4;
    glow.style.width = g + 'px';
    glow.style.height = g + 'px';
    glow.style.top = (h * 0.82) + 'px';      // centred on the flame

    var img = document.createElement('img');
    img.className = 'dw-candle-img';
    img.src = CANDLE_SRC;
    img.alt = '';
    img.width = w;
    img.height = h;
    img.style.width = w + 'px';

    sway.appendChild(glow);
    sway.appendChild(img);
    riseEl.appendChild(sway);
    root.appendChild(riseEl);
    document.body.appendChild(root);

    var anims = [];
    var done = false;
    function cleanup() {
      if (done) return;
      done = true;
      live--;
      anims.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      if (root.parentNode) root.parentNode.removeChild(root);
    }

    if (reduceMotion && reduceMotion.matches) {
      // gentle fade in place, no movement
      anims.push(riseEl.animate(
        [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, offset: 0.3 }, { opacity: 0, transform: 'translateY(-6px)' }],
        { duration: 900, easing: 'ease-in-out', fill: 'forwards' }));
    } else {
      var dur = 1650;
      var drift = rand(-14, 14);
      // pop in, then float up and fade (like a social "like")
      anims.push(riseEl.animate([
        { transform: 'translate(0,0) scale(.25)', opacity: 0 },
        { transform: 'translate(0,-6px) scale(1.18)', opacity: 1, offset: 0.12 },
        { transform: 'translate(0,-12px) scale(.96)', opacity: 1, offset: 0.2 },
        { transform: 'translate(0,-20px) scale(1)', opacity: 1, offset: 0.28 },
        { transform: 'translate(' + (drift * 0.5) + 'px,' + (-rise * 0.6) + 'px) scale(.98)', opacity: 0.9, offset: 0.7 },
        { transform: 'translate(' + drift + 'px,' + (-rise) + 'px) scale(.9)', opacity: 0 }
      ], { duration: dur, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' }));
      // soft side-to-side sway, like a lantern carried up by warm air
      anims.push(sway.animate([
        { transform: 'rotate(0deg)' },
        { transform: 'rotate(-7deg)', offset: 0.3 },
        { transform: 'rotate(6deg)', offset: 0.6 },
        { transform: 'rotate(-3deg)', offset: 0.85 },
        { transform: 'rotate(0deg)' }
      ], { duration: dur, easing: 'ease-in-out', fill: 'forwards' }));
      // flame glow flicker
      anims.push(glow.animate([
        { opacity: 0.55, transform: 'translate(-50%,-50%) scale(.9)' },
        { opacity: 1, transform: 'translate(-50%,-50%) scale(1.12)' },
        { opacity: 0.7, transform: 'translate(-50%,-50%) scale(.97)' },
        { opacity: 0.95, transform: 'translate(-50%,-50%) scale(1.06)' }
      ], { duration: 420, iterations: Math.ceil(dur / 420), direction: 'alternate', easing: 'ease-in-out' }));
      // a few golden sparks drifting up from the tap point
      for (var i = 0; i < 8; i++) {
        var s = document.createElement('div');
        s.className = 'dw-candle-spark';
        var size = rand(6, 11);
        s.style.width = size + 'px';
        s.style.height = size + 'px';
        s.style.marginLeft = (-size / 2) + 'px';
        s.style.marginTop = (-size / 2) + 'px';
        root.appendChild(s);
        var ang = rand(-150, -30) * Math.PI / 180;
        var dist = rand(34, 76);
        var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - rand(10, 30);
        anims.push(s.animate([
          { transform: 'translate(0,0) scale(.4)', opacity: 0 },
          { transform: 'translate(' + (dx * 0.35) + 'px,' + (dy * 0.35) + 'px) scale(1)', opacity: 1, offset: 0.25 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.3)', opacity: 0 }
        ], { duration: rand(700, 1050), delay: rand(0, 160), easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' }));
      }
    }

    anims[0].finished.then(cleanup, cleanup);
    setTimeout(cleanup, 2600); // safety net
  }

  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;              // ignore clicks other scripts fire programmatically
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(TRIGGER);
    if (!btn || btn.closest(EXCLUDE)) return;
    if (btn.tagName === 'BUTTON' && btn.disabled) return;
    var x = e.clientX, y = e.clientY;
    if (!x && !y) {                        // keyboard activation: use the button centre
      var r = btn.getBoundingClientRect();
      x = r.left + r.width / 2;
      y = r.top + r.height / 2;
    }
    try { spawn(x, y - 6); } catch (err) { /* visual only — never interfere with the cart */ }
  }, { capture: true, passive: true });
})();
